<template>
  <div>
    <el-menu class="menu"
             :collapse="collapse"
             :collapse-transition="false"
             background-color="#545c64"
             text-color="#AFB2B5"
             active-text-color="#ffffff"
             :default-openeds="openedids"
             :default-active="defaultmenu">
      <template v-for="item of menus">
        <el-submenu v-if="item.children!==null"
                    :index="item.id+''"
                    :key="item.id">
          <template slot="title">
            <i :class="['el-icon-font',item.icon]"></i>
            <span>{{item.label}}</span>
          </template>
          <el-menu-item v-for="subitem of item.children"
                        :index="subitem.id+''"
                        :key="subitem.id"
                        @click="opentab(subitem)">
            <i :class="['el-icon-font',subitem.icon]"></i>
            <span slot="title">{{subitem.label}}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-if="item.children===null"
                      :index="item.id+''"
                      :key="item.id"
                      @click="opentab(item)">
          <i :class="['el-icon-font',item.icon]"></i>
          <span slot="title">{{item.label}}</span>
        </el-menu-item>
      </template>
      <el-menu-item v-if="showDashboard"
                    index="screen"
                    @click="go_dashboard">
        <i :class="['el-icon-font','el-icon-KPIguanli']"></i>
        <span slot="title">大屏展示</span>
      </el-menu-item>
    </el-menu>
    <el-button type="info"
               index="dashboard"
               class="menu-button"
               :icon="menubuttonicon"
               :style="{ left: menubuttonleft }"
               @click="showmeun"></el-button>
  </div>
</template>

<script>
export default {
  name: 'esleft',
  props: ['menus', 'defaultmenu'],
  data () {
    return {
      collapse: true,
      menubuttonleft: '42px',
      menubuttonicon: 'el-icon-arrow-right',
      openedids: [],
      showDashboard: false
    }
  },
  methods: {
    showmeun () {
      if (this.collapse) {
        this.collapse = false
        this.menubuttonleft = '200px'
        this.menubuttonicon = 'el-icon-arrow-left'
        this.$emit("change-width", "200px")
        this.menus.forEach((ele) => {
          if (ele.children != null) {
            this.openedids.push(ele.id + '')
          }
        })
      } else {
        this.collapse = true
        this.menubuttonleft = '42px'
        this.menubuttonicon = 'el-icon-arrow-right'
        this.$emit("change-width", "42px")
      }
    },
    opentab (tabinfo) {
      this.$emit("add-tab", tabinfo)
    },
    go_dashboard () {
      let routeUrl = this.$router.resolve({
        path: '/dashboardmain'
      })
      window.open(routeUrl.href, '_blank')
      // this.$router.push('/dashboardmain')
    }
  },
  mounted () {
    if (this.$store.getUser().funcs.indexOf('dashboard') > -1) {
      this.showDashboard = true
    }
    this.menus.forEach((ele) => {
      if (ele.children != null) {
        this.openedids.push(ele.id + '')
      }
    })
  },
  updated () {
    if (this.collapse) {
      let objs = document.getElementsByClassName("el-submenu__title");
      for (let i = 0; i < objs.length; i++) {
        //设置每个sbumenu的paddingleft值
        objs[i].style.paddingLeft = "10px"
        objs[i].style.paddingRight = "10px";
      }
      objs = document.getElementsByClassName("el-tooltip");
      for (let i = 0; i < objs.length; i++) {
        //设置每个menu-item的left值
        objs[i].style.left = "-10px"
      }
    }
  }
}
</script>

<style scoped>
.menu {
  height: calc(100vh - 48px);
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.menu-button {
  position: absolute;
  top: calc(50vh - 20px);
  padding: 12px 6px 12px 6px;
  border-radius: 0px 8px 8px 0px;
  border: 0px;
  transition: 0.3s;
  opacity: 0.6;
  z-index: 1999;
  background-color: #545c64;
}
</style>
